import { createSelector } from '@reduxjs/toolkit';
import { ERoomType } from '../../../../packages/JsonQuery';
import { selectRoomType } from 'shared/selectors/jsonQuery';
import { selectRoomTypeLabel } from './selectRoomTypeLabel';

interface IRoomType {
  label: string;
  value: ERoomType;
}

const ROOM_TYPES: IRoomType[] = [
  { label: '1-комнатная', value: ERoomType.FlatOneRoom },
  { label: '2-комнатная', value: ERoomType.FlatTwoRooms },
  { label: '3-комнатная', value: ERoomType.FlatThreeRooms },
  { label: '4-комнатная', value: ERoomType.FlatFourRooms },
  { label: '5-комнатная', value: ERoomType.FlatFiveRooms },
  { label: '6-комнатная', value: ERoomType.FlatManyRooms },
  { label: 'Студия', value: ERoomType.Studio },
  { label: 'Свободная планировка', value: ERoomType.FlatFreeLayout },
];

export const selectRoomTypeFilter = createSelector([selectRoomType, selectRoomTypeLabel], (value, label) => ({
  label: label || 'Комнатность',
  value,
  options: ROOM_TYPES,
}));
